import { action, createRequestTypes } from '../base';

export const notificationCentreActionTypes = {
  GET_NOTIFICATION: createRequestTypes('GET_NOTIFICATION'),
  UPDATE_NOTIFICATION: createRequestTypes('UPDATE_NOTIFICATION'),
};

class NotificationCentreActions {
  getNotifications = (orgId, callback) => action(notificationCentreActionTypes.GET_NOTIFICATION.REQUEST, {
    orgId, callback,
  })

  getNotificationLoading = (getNotificationLoading) => action(notificationCentreActionTypes.GET_NOTIFICATION.LOADING, {
    getNotificationLoading,
  })

  getNotificationSuccess = (getNotificationSuccess) => action(notificationCentreActionTypes.GET_NOTIFICATION.SUCCESS, {
    getNotificationSuccess,
  })

  updateNotifications = (payload, callback) => action(notificationCentreActionTypes.UPDATE_NOTIFICATION.REQUEST, {
    payload,
    callback,
  });

  updateNotificationLoading = (updateNotificationLoading) => action(notificationCentreActionTypes.UPDATE_NOTIFICATION.LOADING, {
    updateNotificationLoading,
  })
}

export default new NotificationCentreActions();
